import { Log } from '../Tracker';

export function convertToPageviewLog(log: Log): Log {
  return {
    ...log,
    navigation_sub: { ...log.navigation_sub, page_url: window.location.href },
    data: { ...log.data, is_opened: true },
  };
}

export function sendWithPageviewHandling(log: Log, sender: (log: Log) => void): void | Promise<void> {
  const processedLog = log.category === 'pageview' ? convertToPageviewLog(log) : log;
  return sender(processedLog);
}
